import React, {useState, useEffect} from "react";

import type {SelectProps} from 'antd';
import { Select } from "antd";
import TowerCraneMachinePlatformApi from "../../api/TowerCraneMachinePlatformApi";
import type { TowerCraneMachinePlatform } from "../../type/TowerCraneMachinePlatformType";
import { ProFormSelectProps } from "@ant-design/pro-form/lib/components/Select";
import { ProFormSelect } from "@ant-design/pro-form";

const TowerCraneMachinePlatformSelector:React.FC<ProFormSelectProps> = (props)=>{

    const [options, setOptions] = useState<[]>([]);

    useEffect(()=>{
        TowerCraneMachinePlatformApi.findTowerCraneMachinePlatformList({
            limit: 100,
            deletedFlag: false,
        }).then((result:any)=>{
            const newOptions = result.map((towerCraneMachinePlatform:TowerCraneMachinePlatform)=>{
                return {
                    key: towerCraneMachinePlatform.id,
                    value: towerCraneMachinePlatform.id,
                    label: towerCraneMachinePlatform.name,
                };
            });

            setOptions(newOptions);
        });
    }, []);

    return (
        <ProFormSelect
            options={options}
            {...props}
        />
    );
};

export default TowerCraneMachinePlatformSelector;